import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment-timezone';
import { TimeServiceBase } from '@app/shared/time.service.base';
var TimeService = /** @class */ (function (_super) {
    tslib_1.__extends(TimeService, _super);
    function TimeService(http) {
        return _super.call(this, http) || this;
    }
    TimeService.prototype.now = function () {
        if (localStorage) {
            var timeZone = localStorage.getItem('timeZone');
            if (timeZone) {
                return moment().tz(timeZone);
            }
        }
        return moment();
    };
    return TimeService;
}(TimeServiceBase));
export { TimeService };
